interface Obj {
  [key: string]: string | number | boolean | Array<any> | Obj;
}

const toCamel = (str: string) =>
  str.replace(/([-_][a-z])/gi, ($1) => $1.toUpperCase().replace('-', '').replace('_', ''));

const isObject = (obj: Obj) => obj === Object(obj) && !Array.isArray(obj) && typeof obj !== 'function';

const snakeToCamel = (obj) => {
  if (isObject(obj)) {
    const n = {};

    Object.keys(obj).forEach((k) => {
      n[toCamel(k)] = snakeToCamel(obj[k]);
    });

    return n;
  }
  if (Array.isArray(obj)) {
    return obj.map((i) => snakeToCamel(i));
  }

  return obj;
};

export default snakeToCamel;
